import { useEffect, useState } from "react";
import { IValueListLight } from "../types/valuelist";
import { ICategory, IOrg, IOrgResponse, isCategory } from "../types/org";
import { ORG_VALUE_LISTS } from "../graphql/valuelist-gql";
import { useApolloClient, useLazyQuery } from "@apollo/client";
import { GET_ORG_CATEGORY } from "../graphql/org-gql";

export default function useOrgTypes(target: ICategory | IOrg | undefined) {

    const [ orgTypes, setOrgTypes] = useState<IValueListLight[]>()
    const [defaultOrgType,setDefaultOrgType] = useState<IValueListLight>()

    const client = useApolloClient();
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})

    const [ getOrgCategory ] = useLazyQuery<IOrgResponse>(GET_ORG_CATEGORY, {
        onCompleted: (data) => {
            setOrgTypes(orgValueLists.orgTypeMap.get(data?.org?.details?.category?.id))
        }
    });

    useEffect(()=>{
        
        if(!isCategory(target) && orgTypes && target?.parentOrg!==null && target?.details?.category.categoryName==='Ministries, Secretariats and Offices'){
            const targetOrgType = target.details.orgType
            const index = orgTypes.findIndex(item=>item.id===targetOrgType.id)
            //console.log("index:",index)
            if(orgTypes.length>index+1 ){
                setDefaultOrgType(orgTypes[index+1])
            }
        }

    },[orgTypes,target])

    useEffect(() => {
        if (target) {
            if (isCategory(target)) {
                setOrgTypes(orgValueLists.topOrgTypeMap.get(target.id))
            } else {
                if (!target?.details?.category) {
                    getOrgCategory({variables:{ orgId:target.id}});
                } else {
                    setOrgTypes(orgValueLists.orgTypeMap.get(target.details?.category.id))
                }
            }
        }
    }, [target])
    
    return { orgTypes, defaultOrgType};
}
